import SessionModel from '../models/secure/SessionModel';
import Utils from '../helpers/Utils';

class AppSession {

    static AUTH_SUCCESS = "active";
    static AUTH_FAILED = "inactive";

    static SESSION_ACTIVE = "active";
    static SESSION_EXPIRED = "expired";
    static SESSION_UNREACHABLE = "unreachable";

    async isAuthenticated() {
        let sessionModel = new SessionModel();
        let sessionId = sessionModel.getSessionId();
        if (Utils.isEmpty(sessionId)) { return false; }

        let authenticated = false;
        await sessionModel.checkSession({ sessionId: sessionId}).then(res => {
            authenticated = (res.data && res.data.status == AppSession.AUTH_SUCCESS) ? true : false;
        });
        return authenticated;
    }

    async isSessionActive() {
        let sessionModel = new SessionModel();
        let sessionId = sessionModel.getSessionId();
        let session_result = "";
        try{
            await sessionModel.checkSession({ sessionId: sessionId}).then(res => {
                if(res.data && res.data.status == AppSession.AUTH_SUCCESS){
                    session_result = AppSession.SESSION_ACTIVE;
                }else if(res.data && res.data.status == AppSession.AUTH_FAILED){
                    session_result = AppSession.SESSION_EXPIRED;
                }
            });
            return session_result;
        }catch(error){
            return AppSession.SESSION_UNREACHABLE;
        }
    }
}

export default AppSession;